import { render, staticRenderFns } from "./SocialSharesSingleTrack.vue?vue&type=template&id=21a6d055&scoped=true&"
import script from "./SocialSharesSingleTrack.vue?vue&type=script&lang=js&"
export * from "./SocialSharesSingleTrack.vue?vue&type=script&lang=js&"
import style0 from "./SocialSharesSingleTrack.vue?vue&type=style&index=0&id=21a6d055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6d055",
  null
  
)

export default component.exports